import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  isDanger?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  isDanger = false
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 overflow-hidden"
      onClick={(e) => {
        e.preventDefault();
        onClose();
      }}
    >
      <div 
        className="bg-background-card rounded-lg shadow-xl w-full max-w-md overflow-hidden animate-modalOpen"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border-dark">
          <h3 className="text-lg font-semibold flex items-center">
            {isDanger && <AlertTriangle size={18} className="mr-2 text-status-danger" />}
            {title}
          </h3>
          <button 
            onClick={(e) => {
              e.preventDefault();
              onClose();
            }}
            className="p-1 rounded-full hover:bg-background-hover text-gray-400 hover:text-gray-200 transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-4">
          <p className="text-text-muted-dark">{message}</p>
        </div>

        {/* Actions */}
        <div className="p-4 border-t border-border-dark flex justify-end gap-3">
          <button
            onClick={(e) => {
              e.preventDefault();
              onClose();
            }}
            className="premium-button-outline"
          >
            {cancelButtonText}
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            className={`${isDanger ? 'bg-red-600 hover:bg-red-700' : 'premium-button-primary'} px-4 py-2 rounded text-white`}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 